<template>
  <div>
    <h1>Catalog Manager</h1>
    <p v-for="(name, id) in apps" :key="id"><router-link :to="{name: 'CatalogManager', params:{id}}">{{ name }}</router-link></p>
  </div>
</template>

<script>
export default {
  computed: {
    apps() {
      return this.$store.getters.apps
    }
  }
}
</script>

<style>
  .pointer {
    cursor: pointer;
  }
</style>